module.exports = __webpack_public_path__ + "img/image.026b714f.svg";